export default __webpack_public_path__ + "static/media/fam.af824e52.png";